import script from "./TranslatorCompletedJobs.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslatorCompletedJobs.vue?vue&type=script&setup=true&lang=js"

import "./TranslatorCompletedJobs.vue?vue&type=style&index=0&id=9043a456&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9043a456"]])

export default __exports__